/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum WebsiteAnalyticsAlertCode {
    NO_RECENT_CLICKS = 'no_recent_clicks',
    CLICK_VOLUME_DROP = 'click_volume_drop',
}
